import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import FieldInfo from '../common/inputs/fieldInfo';
import Spinner from '../common/interface/spinner';
import Select from '../common/inputs/select';
import FetchAutocompleteSelect from '../common/inputs/fetchAutocompleteSelect';

const EntityUseQueryPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeFilters,
    filterValues,
    queryData,
    queryStatus,
    dimensionsListData,
    metricsListData,
    polynomialsListData,
    fullLoading,
    popupState
  } = props;
  let fetchedOptions = [];
  if(InterfaceTooling.popupHasToRender(popupState) && filterValues.entityType!="") {
    switch (filterValues.entityType) {
      case Constants.selectKeys.entityUseQuery.entityTypes.DIMENSION:
          fetchedOptions = dimensionsListData;
        break;
      case Constants.selectKeys.entityUseQuery.entityTypes.METRIC:
          fetchedOptions = metricsListData;
        break;
      case Constants.selectKeys.entityUseQuery.entityTypes.POLYNOMIAL:
          fetchedOptions = polynomialsListData;
        break;
      default:
    }
  }
  return (
    <GlassPopup
      className="form_popup entity_use_query_popup"
      title={(<FormattedMessage id={"entityUseQuery.title"}/>)}
      {...props}
    >
      {(InterfaceTooling.popupHasToRender(popupState)) && (
        <div className="entity_use_query_popup_inner">
          <div className="row_fields">
            <Select
              value={filterValues.entityType}
              labelLocale={<FormattedMessage id="entityUseQuery.entityTypesSelectLabel"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.entityUseQuery.entityTypes","entityUseQuery.entityTypesSelectValues")}
              onChange={handleOnChangeFilters}
              data-path={"entityType"}
            />
            <FetchAutocompleteSelect
              data-path={"entityValue"}
              value={filterValues.entityValue}
              onChange={handleOnChangeFilters}
              labelLocale={intl.formatMessage({id:"entityUseQuery.entitySelectLabel"}) + " " + (filterValues.entityType ? intl.formatMessage({id:"entityUseQuery.entityTypesSelectValues." + filterValues.entityType}) : "...") + ":"}
              options={fetchedOptions ? InterfaceTooling.getSelectArrayFromArrayOfObjects(fetchedOptions, "id", "name", false) : []}
              valueAccesor={"id"}
              labelAccesor={"name"}
              minSearchLength={0}
              fetchListAction={null}
              loadingFetch={false}
            />
          </div>
          <div className="entity_use_query_popup_result_wrapper">
            {(queryStatus==200) ? (
              <label className="entity_use_query_popup_result_title">
                {intl.formatMessage({id:"entityUseQuery.resultLabel"}) + " '" + intl.formatMessage({id:"entityUseQuery.entityTypesSelectValues." + queryData.entity_type}) + ": " + queryData.entity_name + "'"}
              </label>
            ) : (
              <label className="entity_use_query_popup_result_title">
                {intl.formatMessage({id:"entityUseQuery.resultLabel"}) + " ..." }
              </label>
            )}
            {(queryStatus==200) && (
              <div className="entity_use_query_popup_result_data_wrapper">
                {Object.keys(queryData.use_query_result).map(result_key => {
                  let result_key_data = queryData.use_query_result[result_key];
                  let result_elements = result_key_data.map((result_element, result_element_index) => {
                    return (
                      <div key={result_element_index} className="entity_use_query_popup_result_data_block_results_element">
                        {result_element.name + 
                          (result_element.formula_type == Constants.selectKeys.polynomial.formulaType.TABLE ? " (" + intl.formatMessage({id:"entityUseQuery.resultCategoriesTable"}) + ")" : "") +
                          (result_element.is_validation == 1 ? " (" + intl.formatMessage({id:"entityUseQuery.resultCategoriesValidation"}) + ")" : "")
                        }
                      </div>
                    );
                  });
                  return (
                    <div className="entity_use_query_popup_result_data_block">
                      <label className="entity_use_query_popup_result_data_block_label">
                        {intl.formatMessage({id:"entityUseQuery.resultCategoriesIn"}) + " " + intl.formatMessage({id:"entityUseQuery.resultCategories." + result_key}) + ":"}
                      </label>
                      <div className="entity_use_query_popup_result_data_block_results">
                        {result_elements}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </GlassPopup>
  );
};

export default EntityUseQueryPopup;



// WEBPACK FOOTER //
// ./source/client/components/entityUseQuery/entityUseQueryPopup.jsx